<script>
import { h } from 'vue'
import readText from './read-text.vue'
import readTextEditStyle from './read-text-edit-style.vue'
export default {
  name: 'PgReadTextRule',
  props: {
    // 匹配规则 type :warning/success/info/error/primary:可以显示颜色 block: 支持块级颜色
    // {"label":"显示文本","value":"文本对应的实际walue","type":"warning/success/info/error/primary/grey",block:true/false}
    rules: {
      type: Array,
      default: () => [],
    },
    isEditStyle: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { attrs }) {
    return () => {
      const { rules } = props
      if (rules.length > 0) {
        let res = rules.find((item) => {
          return item.value === attrs.value
        })
        const className =
          !res?.block && !res?.type
            ? ''
            : `pg-readText-${res.block ? 'block' : ''}${res.type ? res.type : ''}`
        return h(props.isEditStyle ? readTextEditStyle : readText, {
          props: {
            ...attrs,
            value: res?.label,
          },
          class: `${className}`,
        })
      }
      return h(props.isEditStyle ? readTextEditStyle : readText, { props: attrs })
    }
  },
}
</script>
<style lang="scss">
@import '../style/read-text.scss';
</style>
